export default defineEventHandler((event) => {
    const host = getRequestHeader(event, 'host');
    
    // Wenn Request von cdn.smoxy.app kommt, nicht von Nuxt routen lassen
    if (host?.startsWith('cdn.')) {
      // 404 zurückgeben - CDN sollte nicht von Nuxt bedient werden
      throw createError({
        statusCode: 404,
        statusMessage: 'CDN resources should be served by CDN, not Nuxt'
      });
    }
  });